import http from './httpService';
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/sponsors"

function sponsorUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getSponsors() {
    return http.get(apiEndpoint);
  }
  
  export function getSponsor(sponsor_id) {
    let url = `${apiEndpoint}/${sponsor_id}`;

    return http.get(url);
  }
  
  export function saveSponsor(sponsor) {
    if (sponsor.sponsor_id) {
      const body = { ...sponsor };
      delete body.sponsor_id;
      return http.put(sponsorUrl(sponsor.sponsor_id), body);
    }
  
    return http.post(apiEndpoint, sponsor);
  }
  
  export function deleteSponsor(sponsor_id) {
    return http.delete(sponsorUrl(sponsor_id));
  }

 